import { requestState, responseState } from '../utils';
import { ReviewAction, ReviewActionEnum, ReviewState } from './types';

const initialState: ReviewState = {
  isLoading: {
    add: false,
    delete: false,
    update: false
  },
  result: {}
};
const review = (state = initialState, action: ReviewAction): ReviewState => {
  switch (action.type) {
    case ReviewActionEnum.REQUEST_ADD_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, add: true },
        result: {}
      };

    case ReviewActionEnum.RESULT_ADD_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, add: false },
        result: { add: action.status }
      };

    case ReviewActionEnum.REQUEST_UPDATE_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, update: true },
        result: {}
      };

    case ReviewActionEnum.RESULT_UPDATE_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, update: false },
        result: { update: action.status }
      };

    case ReviewActionEnum.REQUEST_DELETE_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, delete: true },
        result: {}
      };

    case ReviewActionEnum.RESULT_DELETE_REVIEW:
      return {
        ...state,
        isLoading: { ...state.isLoading, delete: false },
        result: { delete: action.status }
      };

    case ReviewActionEnum.CLEAR_REVIEW_RESULT:
      return { ...state, result: {} };

    default:
      return state;
  }
};
export default review;
